import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { CouponPage } from '../coupon/coupon';

/**
 * Generated class for the AddcouponPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addcoupon',
  templateUrl: 'addcoupon.html',
})
export class AddcouponPage {
  couponAdd: any = {};
  searchTerm;
  utenti;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private readonly loadingCtrl: LoadingController,

  ) {
  }

  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 5) {
      this.rest.searcUserClient(this.searchTerm).subscribe(
        utenti => this.utenti = utenti,
        error => this.errorMessage = <any>error);
      if (this.utenti != null) {
        this.LoadData();
      }
    }
  }
  public LoadData() {
    console.log("LoadData this.utenti:" + JSON.stringify(this.utenti));

    console.log("LoadData");

  }
  seleziona(utente) {
    alert("Utente selezionato con successo!")
    this.couponAdd.usercliente = utente;

  }
  salva() {
    if (this.couponAdd.scadenza != null && this.couponAdd.nome != null && this.couponAdd.somma != null && this.couponAdd.codice != null) {
      this.couponAdd.id = null;
      // this.couponAdd.scadenza = "29-10-2019";
      let scadenza = this.couponAdd.scadenza;
      let names = scadenza.split("-");
      let anno = names[0];
      let mese = names[1];
      let giorno = names[2];
      this.couponAdd.scadenza = giorno + "-" + mese + "-" + anno;

      //alert(JSON.stringify(this.couponAdd))
      // alert(anno)
      //alert(mese)
      //alert(giorno)
      let loading = this.loadingCtrl.create({

        spinner: 'bubbles',
        duration: 2000,

        content: 'save settore ...'

      });

      loading.present();




      this.rest.nuovaCoupon(this.couponAdd).subscribe(res => {
        if (res.risposta == "ko")
          alert("codice coupon esiste già")
      },
        error => {
          alert("errore:" + error)

        }
      )

      let hideFooterTimeout1 = setTimeout(() => {
        //  loading.dismiss();
        this.navCtrl.push(CouponPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

      }, 2000);


    } else {
      alert("Valorizza tutti i campi!")
    }

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad AddcouponPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/addcoupon/addcoupon.ts